import { z } from 'zod'

import { ResponsibleMedicalRecord } from './ResponsibleMedicalRecord'

export const ResponsibleMedicalRecordView = z.object({
  sendResponsible: ResponsibleMedicalRecord,
  registerPatient: ResponsibleMedicalRecord,
  registerOperational: ResponsibleMedicalRecord
})
export type ResponsibleMedicalRecordView = z.infer<
  typeof ResponsibleMedicalRecordView
>
